export const CONTINUE_TRANSACTION_STATE = {
  NONE: 'NONE',
  GET_LINK_SUCCESS: 'GET_LINK_SUCCESS',
  FAILURE: 'FAILURE',
}

export const TRANSACTION_STATE = {
  NONE: 'NONE',
  SUCCESS: 'SUCCESS',
  WAITING_FOR_VERIFICATION: 'REDIRECT',

  VERIFIED: 'VERIFIED',
  PAYMENT_PROCESSING: 'PROCESSING',
  ABANDONED: 'ABANDONED',
  FAILED: 'FAILED',
}

export const PAYMENT_METHOD = {
  RFP: 'RFP',
}

export const OBV_TX_TYPE = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
}
